type GetCodeProps = {
  projectId: string;
  country: string;
  language: string;
  clientId?: number;
  responseType?: string;
  state?: string;
  redirectUri?: string;
};

export const widgetLocale = [
  'ru',
  'en',
  'zh',
  'ko',
  'es',
  'fr',
  'pt',
  'it',
  'de',
  'he',
  'ar',
  'tw',
  'vi',
  'cs',
  'pl',
  'bg',
  'ro',
  'tr',
  'th',
  'ja'
];

export const updatedWidgetLocale = [
  'ru',
  'en',
  'cn',
  'ko',
  'es',
  'fr',
  'pt',
  'it',
  'de',
  'he',
  'ar',
  'tw',
  'vi',
  'cs',
  'pl',
  'bg',
  'ro',
  'tr',
  'th',
  'ja',
  'ph',
  'ne',
  'my',
  'lo',
  'km',
  'id'
];

export const getExampleCode = ({
  projectId,
  country,
  language,
  clientId,
  responseType,
  state,
  redirectUri
}: GetCodeProps): string => {
  const requiredParams = () => {
    if (!clientId) {
      return `projectId: "${projectId}",
        callbackUrl: "https://login.xsolla.com/api/blank", // URL to redirect the user to after registration/authentication/password reset.
        preferredLocale: "${language}_${country}"`;
    }

    return `projectId: "${projectId}",
        preferredLocale: "${language}_${country}",
        clientId: "${clientId}",
        responseType: "${responseType}",
        state: "${state}",
        redirectUri: "${redirectUri}"`;
  };

  return `<div id="xl_auth" style="width: 100%; height: 1000px"></div>
        
  <script type="application/javascript">
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = "https://login-sdk.xsolla.com/latest/";
    const head = document.getElementsByTagName("head")[0];
    head.appendChild(s);
    let xl;
  
    s.addEventListener("DOMContentLoaded", function() {
      xl = new XsollaLogin.Widget({
        ${requiredParams()}
      });
  
      xl.mount("xl_auth");
    });
    
    // function for opening a widget by button
    function openWidget() {
      xl.open();
    } 
  </script>`;
};
